
<!--
 * @Description: 业务须知
--> 
<template>
  <div class="must-know">
    <van-nav-bar v-show="$comm.titleShow()" left-text="返回" :title="title" @click-left="$comm.onClickLeft" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <van-tabs color="#1677FF" v-model="active" @change="onChange" sticky>
      <van-tab v-for="(tab, i) in tabs" :key="i" :title="tab.title">
        <div class="comm-seperator"></div>
        <div v-show="active===0" class="must-know-list">
          <van-list v-model="loading" :finished="finished" :finished-text="'没有更多了'" @load="onLoad" :immediate-check="false">
            <div v-for="(article, i) in articleList" :key="i">
              <must-know-item :article="article" :title="title"></must-know-item>
            </div>
          </van-list>
        </div>
        <div v-show="active===3" class="sales-net-list">
          <div v-for="(site, i) in articleList" :key="i">
            <sales-net-item :site="site"></sales-net-item>
            <div class="comm-seperator"></div>
          </div>
        </div>
        <div v-show="active===1||active===2">
          <pay-way :article="article" :title="title"></pay-way>
        </div>
      </van-tab>
    </van-tabs>
    <div style="height:57px"></div>
    <home-bar></home-bar>
  </div>
</template>

<script>
import MustKnowItem from './MustKnowItem'
import SalesNetItem from './SalesNetItem'
import PayWay from './PayWay'
import HomeBar from '@/components/HomeBar.vue'
export default {
  name: 'MustKnow',
  components: {
    MustKnowItem,
    SalesNetItem,
    PayWay,
    HomeBar
  },
  data() {
    return {
      active: 0,
      tabs: [
        {
          title: '业务指南'
        },
        {
          title: '缴费方式'
        },
        {
          title: '水价标准'
        },
        {
          title: '服务网点'
        }
      ],
      payWayContent: '',
      typeCode: 101,
      articleList: [],
      article: {
        ftitle: '',
        fissuedate: '',
        fhits: '',
        fcontent: ''
      },
      siteList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      title: ''
    }
  },
  mounted() {
    if (this.$route.query.active) {
      this.active = Number(this.$route.query.active)
    }
    this.onChange(this.active)
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.articleList = []
          this.refreshing = false
          this.page = 1
        } else {
          this.page++
        }
        this.getSiteData()
      }, 1000)
    },
    onChange(value) {
      console.log(value)
      if (value === 0) {
        this.typeCode = 116 // 业务指南
        this.title = '业务指南'
        this.getSiteData()
        return
      } else if (value === 1) {
        this.typeCode = 222 // 缴费方式
        this.title = '缴费方式'
      } else if (value === 2) {
        this.typeCode = 113 // 水价标准
        this.title = '水价标准'
      } else {
        this.typeCode = 126 // 服务网点
        this.title = '服务网点'
      }
      this.getArticleData()
    },
    getSiteData() {
      let params = {
        "typecode": 116,
        "pagesize": 20,
        "pageindex": this.page
      }
      if (this.page === 1) {
        this.articleList = []
      }
      this.loading = true
      this.$http.post(this.$api.getArticles, params).then(res => {
        this.loading = false
        if (res.data && res.data.length > 0) {
          this.articleList = this.articleList.concat(res.data)
          if (this.articleList.length >= parseInt(res.totalcount)) {
            this.finished = true
          }
        } else {
          this.finished = true
        }
      })
    },
    getArticleData() {
      let params = {
        "typecode": this.typeCode,
        "pagesize": 20,
        "pageindex": 1
      }
      this.articleList = []
      this.$loading()
      this.$http.post(this.$api.getArticles, params).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.articleList = res.data
          // 水价标准和缴费方式
          if (this.active === 2 || this.active === 1) {
            if (this.articleList.length > 0) {
              this.getArticleDataInfo(this.articleList[0].fid)
            }
          }
        } else {
          this.$toast(res.msg)
        }
      })
    },
    getArticleDataInfo(fid) {
      let params = {
        "fid": fid,
      }
      this.$http.post(this.$api.getArticle, params).then(res => {
        if (res.code === '000') {
          this.article = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.must-know {
  .sales-net-list {
    padding: 0 16px;
  }
}
</style>